<template>
  <div class="topic_banner">
<!--    <div class="bannerBetween">-->
<!--      <el-carousel v-if="bannerData[0]" :indicator-position="(bannerData[0].list.length>1?'':'none')" :autoplay="true"-->
<!--                   arrow="never" class="el-carousel bannerImgs" :interval="8000">-->
<!--        <el-carousel-item v-for="(item,index) in bannerData[0].list" :key="index">-->
<!--          <img :src="item.url" @click="imgRouter(item)"/>-->
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->
<!--      <el-carousel v-if="bannerData[1]" :indicator-position="(bannerData[1].list.length>1?'':'none')" :autoplay="true"-->
<!--                   arrow="never" class="el-carousel bannerImgs" :interval="8000">-->
<!--        <el-carousel-item v-for="(item,index) in bannerData[1].list" :key="index">-->
<!--          <img :src="item.url" @click="imgRouter(item)"/>-->
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->
<!--    </div>-->
    <el-carousel v-if="bannerData[2]" :indicator-position="(bannerData[2].list.length>1?'':'none')" :autoplay="true"
                 arrow="never" class="el-carousel bannerImg" :interval="8000">
      <el-carousel-item v-for="(item,index) in bannerData[2].list" :key="index">
        <img :src="item.url" @click="imgRouter(item,2)"/>
      </el-carousel-item>
    </el-carousel>
<!--    <el-carousel v-if="bannerData[3]" :indicator-position="(bannerData[3].list.length>1?'':'none')" :autoplay="true"-->
<!--                 arrow="never" class="el-carousel bannerImg" :interval="8000">-->
<!--      <el-carousel-item v-for="(item,index) in bannerData[3].list" :key="index">-->
<!--        <img :src="item.url" @click="imgRouter(item)"/>-->
<!--      </el-carousel-item>-->
<!--    </el-carousel>-->

    <div class="bannerBetween">
      <el-carousel v-if="bannerData[0]" :indicator-position="(bannerData[0].list.length>1?'':'none')" :autoplay="true"
                   arrow="never" class="el-carousel bannerImgs" :interval="8000">
        <el-carousel-item v-for="(item,index) in bannerData[0].list" :key="index">
          <img :src="item.url" @click="imgRouter(item)"/>
        </el-carousel-item>
      </el-carousel>
      <el-carousel v-if="bannerData[1]" :indicator-position="(bannerData[1].list.length>1?'':'none')" :autoplay="true"
                   arrow="never" class="el-carousel bannerImgs" :interval="8000">
        <el-carousel-item v-for="(item,index) in bannerData[1].list" :key="index">
          <img :src="item.url" @click="imgRouter(item)"/>
        </el-carousel-item>
      </el-carousel>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    bannerData: {
      type: [Object, Array],
      default: []
    }
  },
  data() {
    return {}
  },
  created() {

  },
  mounted() {
  },
  methods: {
    goRouter(item) {
      console.log(item)
      // "type": 0,//跳转类型（1外链2文章3专题）
      // "relateId": "",//跳转类型1时为外链地址，2为文章id，3为专题id）
    },
    imgRouter(item, index) {
      if (item.type == 1 && item.relateId && (item.relateId != null)) {
        window.open(item.relateId, "_blank")
      } else if (item.type == 2) {
        window.open('/newsDetail?DetailId=' + item.relateId, "_blank");
      } else if (item.type == 3) {
        if (index) {
          window.open('/spacilPage1', "_blank");
          return;
        }
        if (item.relateId == 523) {
          window.open('/spacilPage2', "_blank");
          return;
        }
        if (item.relateId == 260) {
          window.open('/spacilPage3', "_blank");
          return;
        }
        if (item.module) {
          window.open('/topList?topic=' + item.relateId, "_self");
        } else {
          window.open('/topList1?topic=' + JSON.stringify({topic: item.relateId}), "_self");
        }
      } else if (item.type == 4) {
        window.open('/importNews?id=' + item.relateId, "_blank");
      }
    }
  }
};
</script>
<style lang="scss" scoped>

/deep/ .bannerBetween {
  height: 66px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;

  .bannerImgs {
    width: 49.5%;
    height: 66px;

    .el-carousel__container {
      height: 66px;
    }

    img {
      height: 100%;
      width: 100%;
      cursor: pointer;
    }
  }
}

/deep/ .bannerImg {
  width: 100%;
  height: 66px;
  margin-bottom: 10px;

  .el-carousel__container {
    height: 66px;
  }

  img {
    height: 100%;
    width: 100%;
    cursor: pointer;
  }
}

/deep/ .el-carousel {
  .el-carousel__indicators {
    padding: 0 !important;
  }

  .el-carousel__indicators--horizontal {
    left: auto;
    right: 10px;
    transform: translateX(0);

    .el-carousel__indicator--horizontal {
      padding: 6px 4px !important;

      .el-carousel__button {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        opacity: 1;
        background: rgba($color: #fff, $alpha: 0.5);
      }
    }

    .is-active {
      .el-carousel__button {
        background: #E00001;
      }

    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/index/indexBannerTop.vue